export enum HistoryEvent {
  PUSH = 'PUSH',
  REPLACE = 'REPLACE',
  RESET = 'RESET',
  POP = 'POP',
}

type Listener = (e?: HistoryEvent) => void

export class Listeners {
  private static listeners: Listener[] = []

  static listen(listener: Listener) {
    Listeners.listeners.push(listener)
    return () => {
      Listeners.listeners = Listeners.listeners.filter(fn => fn !== listener)
    }
  }

  static notify(event: HistoryEvent) {
    Listeners.listeners.forEach(fn => fn(event))
  }
}
